import newsAPI from 'media-base-ui/utils/newsAPI';

import actionCreators from './actionCreators';

const DEFAULT_START = 0;
const DEFAULT_LIMIT = 50;

const clearCache = actionCreators.clearCache;

const fetchNewsById = (isPublic, ...ids) =>  dispatch => {
    fetchNextNewsByIds(undefined, ids.length, null, isPublic, ids)(dispatch);
};

const fetchNextNewsByIds = (currentStart = DEFAULT_START, limit = DEFAULT_LIMIT, total, isPublic = false, ids) =>
        dispatch => {
    fetchNextNews(currentStart, limit, null, total, null, null, isPublic, ids)(dispatch);
};

const fetchNewsByTypes = (fromDate, types, section, limit, isPublic = false) => dispatch => {
    fetchNextNewsByTypes(undefined, limit, fromDate, null, types, section)(dispatch);
};

const fetchNextNewsByTypes = (currentStart = DEFAULT_START, limit = DEFAULT_LIMIT, fromDate, total, types, section, isPublic) =>
        dispatch => {
    fetchNextNews(currentStart, limit, fromDate, total, types, section, isPublic)(dispatch);
};

const fetchNextNews = (start, limit, fromDate, total, types, section, isPublic, ids) => async dispatch => {
    // if we have never requested anything, then make a request
    if (!total || start < total) {
        dispatch(actionCreators.requestNews(start, limit, fromDate));

        try {
            const data = await newsAPI.fetchNews({
                start,
                limit,
                fromDate,
                types,
                section,
                isPublic,
                ids
            });
            const sluggedItems = newsAPI.addNewsTypeSlugs(data.data, true);
            dispatch(actionCreators.newsResponse(true, sluggedItems, data.total, []));
        } catch (error) {
            dispatch(actionCreators.newsResponse(false, [], null, error));
        }
    }
};

export default {
    fetchNewsById,
    fetchNextNewsByIds,
    fetchNewsByTypes,
    fetchNextNewsByTypes,
    clearCache
};
